/* ───────────────────────────────────────────────────────────────────────────
   DN5 · PDP 2c — display-layer script
   🔴 Not one cent is calculated here. Price / tiers / Save / free shipping / gift totals are all computed by the
      existing engine (theme.bundle-savings-unify-v42 + dn2-pdp-price-owner-scroll-v5) and
      written into the DOM. This file keeps five display-layer responsibilities:
        ① expand/collapse (accordions, sheets)
        ② draw the JSON Liquid puts in the DOM as tables (size chart, gift details)
        ③ date copy (ships / arrives, plain calendar arithmetic, nothing to do with money)
        ④ carry over the three glue scripts from the black section that "must move with the section":
           tier → native selector reverse sync / default variant auto-pick / size label follow
        ⑤ arrange the existing live review nodes and keep their one Write button in the correct column
        ⑥ bundle item colour / size panels: colour circle value, footer links, tier card height re-fit (§ 14)
        ⑦ Perfect Pair tier: stacked thumbnails, item names / index, companion VIEW thumbnail → shared Quick View (§ 15)
      The carried list and the reasons are in ENGINE-CONTRACT.md §5.10.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var ROOT_SEL = '.dn5p';
  function root() { return document.querySelector(ROOT_SEL); }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  /* ═══ 1 · accordions ═══ */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var h = e.target.closest ? e.target.closest('.dn5p-acc__h') : null;
      if (!h) return;
      var acc = h.closest('[data-dn5p-acc]');
      if (!acc) return;
      var open = !acc.classList.contains('is-open');
      acc.classList.toggle('is-open', open);
      h.setAttribute('aria-expanded', open ? 'true' : 'false');
      var ico = h.querySelector('.dn5p-acc__i');
      if (ico) ico.textContent = open ? '−' : '+';
    });
  }

  /* ═══ 2 · sheets (dn5's own switch; the engine's data-dn2-open is not reused, to avoid double binding) ═══ */
  var lockY = 0, lockCount = 0;
  function lock() {
    if (lockCount++ > 0) return;
    lockY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.style.overflow = 'hidden';
    /* iOS: overflow:hidden does not stop touch scroll-through; pinning the body is the real lock */
    var b = document.body.style;
    b.position = 'fixed'; b.top = (-lockY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unlock() {
    if (lockCount > 0 && --lockCount > 0) return;
    lockCount = 0;
    document.documentElement.style.overflow = '';
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    /* the site html may have smooth scroll on; restoring the position must be instant, or the page visibly drifts back */
    var sb = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, lockY);
    document.documentElement.style.scrollBehavior = sb;
  }
  function openSheet(el) {
    if (!el || el.classList.contains('is-open')) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lock();
    var x = el.querySelector('[data-dn5p-close]');
    if (x && x.focus) { try { x.focus({ preventScroll: true }); } catch (e) {} }
  }
  function closeSheet(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    unlock();
  }
  function initSheets() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      var opener = t.closest('[data-dn5p-open]');
      if (opener) { e.preventDefault(); openSheet(document.getElementById(opener.getAttribute('data-dn5p-open'))); return; }
      var closer = t.closest('[data-dn5p-close]');
      if (closer) { e.preventDefault(); closeSheet(closer.closest('.dn5p-sheet')); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('.dn5p-sheet.is-open').forEach(closeSheet);
    });
  }

  /* ═══ 3 · size chart: draw the table + cm/inch + highlight the selected size ═══ */
  var sgUnit = 'cm', sgDocBound = false;
  function sgTables() {
    var el = document.getElementById('dn5p-size-guide-data');
    if (!el) return null;
    try {
      var raw = el.getAttribute('data-tables');
      if (!raw) return null;
      var t = JSON.parse(raw);
      return (t && t.length) ? t : null;
    } catch (e) { return null; }
  }
  function selectedSizeValue() {
    var sels = $$('[data-native-option-selector]');
    for (var i = 0; i < sels.length; i++) {
      if ((sels[i].dataset.optionName || '').toLowerCase() !== 'size') continue;
      var on = sels[i].querySelector('.size-btn.is-selected,[data-native-option-value].is-selected');
      if (on) return (on.dataset.nativeOptionValue || on.textContent || '').trim();
    }
    return '';
  }
  function cmToIn(v) {
    var n = parseFloat(String(v).replace(/[^\d.\-]/g, ''));
    if (!isFinite(n)) return v;
    return (Math.round((n / 2.54) * 10) / 10).toString();
  }
  function renderSizeGuide() {
    var tables = sgTables();
    var wrap = $('#dn5p-size-guide [data-dn5p-sg-tables]');
    if (!tables || !wrap) return;
    var sel = selectedSizeValue().toLowerCase();
    var html = '';
    /* The proto 0/16/2 chart is grid rows, not a <table>:
       column template 64px + equal columns (last one 1.3fr), header JetBrains Mono 10.5px,
       row height 46, ordinary rows dashed bottom line, selected row blue frame + light fill. */
    tables.forEach(function (t) {
      var srcUnit = String(t.unit || 'cm').toLowerCase();
      var convert = (sgUnit === 'inch' && srcUnit.indexOf('cm') === 0);
      var heads = (t.headers && t.headers.length) ? t.headers : [];
      var ncol = heads.length;
      if (!ncol) {
        (t.rows || []).forEach(function (r) { if (r && r.length > ncol) ncol = r.length; });
      }
      if (!ncol) return;
      var cols = ['64px'];
      for (var c = 1; c < ncol; c++) cols.push(c === ncol - 1 && ncol >= 4 ? 'minmax(96px,1.3fr)' : 'minmax(84px,1fr)');
      var minWidth = 64 + (ncol - 1) * 84 + (ncol - 1) * 6 + 28 + (ncol >= 4 ? 12 : 0);
      html += '<div class="dn5p-sgt" style="--dn5p-sgt-cols:' + cols.join(' ') + ';min-width:max(100%,' + minWidth + 'px)">';
      if (t.title) {
        var inchSuffix = (document.getElementById('dn5p-size-guide-data') || {}).getAttribute
          ? (document.getElementById('dn5p-size-guide-data').getAttribute('data-inch-suffix') || '(in)')
          : '(in)';
        html += '<div class="dn5p-sgt__cap">';
        if (t.image) html += '<img class="dn5p-sgt__image" src="' + esc(t.image) + '" alt="' + esc(t.title) + '" width="48" height="48" loading="lazy">';
        html += '<span>' + esc(t.title) +
          (sgUnit === 'inch' ? ' ' + esc(inchSuffix) : (srcUnit ? ' (' + esc(srcUnit) + ')' : '')) + '</span></div>';
      }
      if (heads.length) {
        html += '<div class="dn5p-sgt__r dn5p-sgt__r--head">';
        heads.forEach(function (h) { html += '<span>' + esc(h) + '</span>'; });
        html += '</div>';
      }
      (t.rows || []).forEach(function (row) {
        var first = String((row && row[0]) || '').trim().toLowerCase();
        html += '<div class="dn5p-sgt__r dn5p-sgt__r--body' + (sel && first === sel ? ' is-sel' : '') + '">';
        for (var ci = 0; ci < ncol; ci++) {
          var cell = (row || [])[ci];
          var v = (convert && ci > 0) ? cmToIn(cell) : cell;
          html += '<span>' + esc(v == null ? '' : v) + '</span>';
        }
        html += '</div>';
      });
      html += '</div>';
    });
    wrap.innerHTML = html;

    var noteEl = $('#dn5p-size-guide [data-dn5p-sg-note]');
    var helpEl = $('#dn5p-size-guide [data-dn5p-sg-help]');
    var data = document.getElementById('dn5p-size-guide-data');
    if (data) {
      var note = data.getAttribute('data-note') || '';
      var hT = data.getAttribute('data-help-text') || '';
      var hU = data.getAttribute('data-help-url') || '';
      if (noteEl) { noteEl.textContent = note; noteEl.hidden = !note; }
      /* in the proto the help link is its own centred line (0/16/4), not trailing the hint */
      if (helpEl) {
        if (hT) { helpEl.textContent = hT; helpEl.hidden = false; if (hU) helpEl.setAttribute('href', hU); else helpEl.removeAttribute('href'); }
        else { helpEl.hidden = true; }
      }
    }
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function initSizeGuide() {
    if (!sgTables()) return;                       /* no table data → no entry point */
    $$('.dn5p-sgtrig[data-dn5p-open="dn5p-size-guide"]').forEach(function (b) { b.hidden = false; });
    renderSizeGuide();
    $$('#dn5p-size-guide [data-dn5p-unit]').forEach(function (b) {
      b.addEventListener('click', function () {
        sgUnit = b.getAttribute('data-dn5p-unit');
        $$('#dn5p-size-guide [data-dn5p-unit]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        renderSizeGuide();
      });
    });
    /* when reopened after a size was picked, the matching row is highlighted (document level, bound once) */
    if (!sgDocBound) {
      sgDocBound = true;
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-native-option-selector]')) setTimeout(renderSizeGuide, 60);
      }, true);
    }
  }

  /* ═══ 4 · gift details sheet ═══ */
  function giftData() {
    var el = $('[data-dn5p-gifts]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }
  function initGiftDetail() {
    var gifts = giftData();
    if (!gifts.length) return;
    var sheet = document.getElementById('dn5p-gift-detail');
    if (!sheet) return;
    var current = 0;
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-dn5p-gift-detail]') : null;
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();                         /* do not let it select the gift card on the way */
      current = parseInt(b.getAttribute('data-dn5p-gift-detail'), 10) || 0;
      var g = gifts[current];
      if (!g) return;
      var t = $('[data-dn5p-gd-title]', sheet); if (t) t.textContent = g.title || '';
      var p = $('[data-dn5p-gd-price]', sheet); if (p) p.textContent = g.price || '';
      var bd = $('[data-dn5p-gd-body]', sheet); if (bd) bd.textContent = g.body || '';
      var im = $('[data-dn5p-gd-images]', sheet);
      if (im) im.innerHTML = (g.images || []).map(function (u) {
        return '<img src="' + esc(u) + '" alt="" loading="lazy" style="width:100%;border-radius:12px;">';
      }).join('');
      openSheet(sheet);
    });
    var pick = $('[data-dn5p-gd-select]', sheet);
    if (pick) pick.addEventListener('click', function () {
      var g = gifts[current];
      /* selection is left to the engine's own .gift-option-card click handler; this only clicks it for the user */
      var card = g && document.querySelector('.gift-option-card[data-gift-id="' + g.cardId + '"]');
      if (card) card.click();
      var sw = document.getElementById('gift-switch');
      var toggle = document.getElementById('gift-toggle');
      if (sw && toggle && !sw.classList.contains('is-on')) toggle.click();
      closeSheet(sheet);
    });
  }

  /* ═══ 5 · shipping journey dates (calendar only, no money) ═══ */
  function addBizDays(d, n) {
    var out = new Date(d.getTime());
    var left = Math.max(0, n | 0);
    while (left > 0) {
      out.setDate(out.getDate() + 1);
      var w = out.getDay();
      if (w !== 0 && w !== 6) left--;
    }
    return out;
  }
  function fmt(d) {
    /* fixed English month names like the proto ("Oct 19"); must not follow the browser language */
    try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
    catch (e) { return (d.getMonth() + 1) + '/' + d.getDate(); }
  }
  function initJourney() {
    $$('[data-dn5p-journey]').forEach(function (host) {
      var ship = parseInt(host.getAttribute('data-ship-days') || '1', 10);
      var dmin = parseInt(host.getAttribute('data-deliv-min') || '7', 10);
      var dmax = parseInt(host.getAttribute('data-deliv-max') || '15', 10);
      var now = new Date();
      var shipAt = addBizDays(now, ship);
      var a1 = addBizDays(shipAt, dmin);
      var a2 = addBizDays(shipAt, dmax);
      var set = function (key, txt) {
        var el = host.querySelector('[data-dn5p-date="' + key + '"]');
        if (el) el.textContent = txt;
      };
      /* proto: "Today" (static label from the block, rendered by Liquid) / "by Oct 19" / "Oct 25 – Nov 2" */
      var pre = (host.getAttribute('data-ship-prefix') || '').trim();
      set('ship', (pre ? pre + ' ' : '') + fmt(shipAt));
      set('deliv', fmt(a1) + ' \u2013 ' + fmt(a2));
    });
  }

  /* ═══ 6 · carried glue ①: picking colour/size in a tier card → click the native selector back ═══
     Source: the black product-main.liquid <script data-dn-bundle-to-native-sync>
     Why it is needed: when the engine builds the add-to-cart items it reads the native selector's .color-swatch.is-active;
     clicking only in the tier card is not enough. */
  function initBundleToNativeSync() {
    var bundles = $('.bundle-tiers');
    if (!bundles) return;
    function selectorFor(name) {
      var sels = $$('[data-native-option-selector]');
      for (var i = 0; i < sels.length; i++) {
        if ((sels[i].dataset.optionName || '').toLowerCase() === (name || '').toLowerCase()) return sels[i];
      }
      return null;
    }
    function syncNative(name, val) {
      var sel = selectorFor(name);
      if (!sel || val == null) return;
      var btns = sel.querySelectorAll('[data-native-option-value]');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        var bv = b.dataset.nativeOptionValue || b.dataset.colorName || b.textContent.trim();
        if (bv !== val) continue;
        if (b.classList.contains('is-active') || b.classList.contains('is-selected')) return;
        b.click();
        return;
      }
    }
    bundles.addEventListener('click', function (e) {
      var tier = e.target.closest('.bundle-tier');
      if (!tier || tier !== bundles.querySelector('.bundle-tier')) return;   /* sync with the first tier only */
      var colorBtn = e.target.closest('.tier-color-btn:not(.tier-upsell-color-btn)');
      if (colorBtn) {
        var cg = colorBtn.closest('.tier-opt-group');
        syncNative(cg ? (cg.dataset.optName || 'Color') : 'Color', colorBtn.dataset.color);
        return;
      }
      var sizeBtn = e.target.closest('.size-btn[data-size]');
      if (sizeBtn) {
        var sg = sizeBtn.closest('.tier-opt-group');
        syncNative(sg ? (sg.dataset.optName || 'Size') : 'Size', sizeBtn.dataset.size);
      }
    });
  }

  /* ═══ 7 · carried glue ②: every option auto-picks its first available value ═══
     Source: <script data-pdp-default-variant>. The two delayed runs are the original behaviour, kept:
     the engine has to build the tier cards first; clicking too early gets overwritten. */
  function initDefaultVariant() {
    function run() {
      $$('[data-native-option-selector]').forEach(function (sel) {
        var btns = sel.querySelectorAll('[data-native-option-value]');
        for (var i = 0; i < btns.length; i++) {
          if (btns[i].classList.contains('is-active') || btns[i].classList.contains('is-selected')) return;
        }
        for (var j = 0; j < btns.length; j++) {
          var b = btns[j];
          if (!b.disabled && b.getAttribute('aria-disabled') !== 'true' && !b.classList.contains('is-disabled')) { b.click(); break; }
        }
      });
    }
    /* 🔴 2026-10-17: two runs are not enough. At 390 width "state right but not highlighted" shows up now and then —
       the button has no .is-selected while .dn2-size-sel already reads "— M" and the engine button already says
       ADD 2 ITEMS, meaning that click landed before the engine bound its own size handler (race).
       Shoppers would see a row with nothing selected yet be able to add to cart. Two self-check runs are added: only when
       "nothing is selected" click the first available value once more — exactly the same meaning as the original two runs,
       no new behaviour, no money touched.
       (This glue was carried from the black [data-pdp-default-variant]; the black skin has the same race.) */
    setTimeout(run, 400);
    setTimeout(run, 1000);
    setTimeout(run, 2000);
    setTimeout(run, 3500);
  }

  /* ═══ 8 · carried glue ③: the "SIZE — M" value follows the selection ═══ */
  function initSizeLabel() {
    $$('.size-selector').forEach(function (sel) {
      var lab = sel.querySelector('.dn2-size-sel');
      if (!lab) return;
      sel.addEventListener('click', function (e) {
        var b = e.target.closest('.size-btn');
        if (!b || b.disabled) return;
        lab.textContent = '— ' + b.textContent.trim();
      }, true);
    });
  }

  /* ═══ 9.2 · keyboard access for tier cards (new proto spec card 02 lists a "keyboard" state) ═══
     The engine's tier cards are divs without tabindex, unreachable by keyboard, so that state could not be drawn.
     Three things only: give the card tabindex / role, Enter·Space act as a click, styling is CSS :focus-visible.
     🔴 Not one cent is calculated: it triggers the engine's own click path (.bundle-tier > .px-4), no amount touched. */
  function initTierKeyboard() {
    var wrap = $('.bundle-tiers');
    if (!wrap) return;
    function arm() {
      $$('.bundle-tier', wrap).forEach(function (t) {
        if (t.getAttribute('tabindex') === null) {
          t.setAttribute('tabindex', '0');
          t.setAttribute('role', 'radio');
        }
        t.setAttribute('aria-checked', t.classList.contains('is-active') ? 'true' : 'false');
      });
    }
    arm();
    try { new MutationObserver(arm).observe(wrap, { childList: true, subtree: true }); } catch (e) {}
    wrap.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var tier = e.target.closest ? e.target.closest('.bundle-tier') : null;
      if (!tier || e.target.closest('button,select,input,a')) return;
      e.preventDefault();
      var hit = tier.querySelector('.px-4') || tier;
      hit.click();
      setTimeout(arm, 60);
    });
    wrap.addEventListener('click', function () { setTimeout(arm, 60); });
  }

  /* ═══ 9.5 · size quick-pick in the floating bar (proto 0/9/1/0/2) ═══
     🔴 Not one cent calculated and the engine is not touched: a tap is just .click() on the native size button,
        and the selected state is mirrored one way from the native selector. Same pattern as the bundle→native code in §6. */
  function initFloatSizes() {
    var host = $('[data-dn5p-float-sizes]');
    if (!host) return;
    var name = (host.getAttribute('data-option-name') || 'Size').toLowerCase();
    function nativeSel() {
      var sels = $$('[data-native-option-selector]');
      for (var i = 0; i < sels.length; i++) {
        if ((sels[i].dataset.optionName || '').toLowerCase() === name) return sels[i];
      }
      return null;
    }
    function mirror() {
      var sel = nativeSel();
      if (!sel) return;
      var on = sel.querySelector('[data-native-option-value].is-selected,[data-native-option-value].is-active');
      var cur = on ? (on.dataset.nativeOptionValue || on.textContent.trim()) : '';
      $$('[data-dn5p-float-size]', host).forEach(function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-dn5p-float-size') === cur);
      });
    }
    host.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-dn5p-float-size]') : null;
      if (!b || b.disabled) return;
      var sel = nativeSel();
      if (!sel) return;
      var want = b.getAttribute('data-dn5p-float-size');
      var btns = sel.querySelectorAll('[data-native-option-value]');
      for (var i = 0; i < btns.length; i++) {
        if ((btns[i].dataset.nativeOptionValue || btns[i].textContent.trim()) === want) {
          if (!btns[i].disabled) btns[i].click();
          break;
        }
      }
      setTimeout(mirror, 60);
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-native-option-selector]')) setTimeout(mirror, 60);
    }, true);
    mirror();
    setTimeout(mirror, 500);
    setTimeout(mirror, 1200);
  }

  /* ═══ 10 · share ═══ */
  /* 9.6 · sticky bar 2nd line = proto "{{colorName}} · {{sizeName}} · {{tierLabel}}" (phones 0/1) /
     "{{colorName}} · {{tierLabel}}" (desktop 0/9). No money: option values come from the native selectors,
     the tier label from the active tier card's own title (the node the engine reads for #floating-tier-info).
     Re-read whenever the engine rewrites #floating-state, so the line follows the engine's state. */
  function initFloatSub() {
    var bar = $('.floating-atc');
    var sub = bar ? $('[data-dn5p-float-sub]', bar) : null;
    if (!sub || sub.getAttribute('data-bound')) return;
    sub.setAttribute('data-bound', '1');
    var mq = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
    function picked(isColor) {
      var sels = $$('[data-native-option-selector]');
      for (var i = 0; i < sels.length; i++) {
        var n = (sels[i].dataset.optionName || '').toLowerCase();
        if ((n === 'color' || n === 'colour') !== isColor) continue;
        var on = sels[i].querySelector('[data-native-option-value].is-selected,[data-native-option-value].is-active');
        return on ? (on.dataset.nativeOptionValue || on.textContent.trim()) : '';
      }
      return null;
    }
    var variants = null;
    function colorImg(c) {
      if (variants === null) {
        try { variants = JSON.parse(($('#bd-variants') || {}).textContent || '[]'); } catch (e) { variants = []; }
      }
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v && v.image && v.options && v.options.indexOf(c) !== -1) return String(v.image).replace(/([?&])width=\d+/, '$1width=160');
      }
      return '';
    }
    function render() {
      var parts = [];
      var color = picked(true);
      if (color) parts.push(color);
      if (!(mq && mq.matches)) {
        var size = picked(false);
        if (size !== null) parts.push(size || sub.getAttribute('data-no-size') || '');
      }
      var tier = $('.bundle-tier.is-active');
      var lab = tier ? tier.querySelector('.bundle-tier__radio + div span') : null;
      if (lab && lab.textContent.trim()) parts.push(lab.textContent.trim());
      var txt = parts.filter(Boolean).join(' \u00b7 ');
      if (sub.textContent !== txt) sub.textContent = txt;
      sub.hidden = !txt;
      if (txt) bar.setAttribute('data-dn5p-sub', '1'); else bar.removeAttribute('data-dn5p-sub');
      /* thumb tile follows the selected colour like the proto's colorBg tile: first variant image of that colour (#bd-variants) */
      var tImg = $('.dn5p-float__img img', bar);
      var src = color ? colorImg(color) : '';
      if (tImg && src && tImg.getAttribute('src') !== src) {
        tImg.removeAttribute('srcset'); tImg.removeAttribute('sizes'); tImg.setAttribute('src', src);
      }
    }
    var st = $('#floating-state', bar);
    if (st && window.MutationObserver) new MutationObserver(render).observe(st, { childList: true, subtree: true, characterData: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-native-option-selector],.bundle-tier')) setTimeout(render, 60);
    }, true);
    if (mq) { if (mq.addEventListener) mq.addEventListener('change', render); else if (mq.addListener) mq.addListener(render); }
    render();
    setTimeout(render, 500);
  }

  function initShare() {
    $$('[data-dn5p-share]').forEach(function (b) {
      b.addEventListener('click', function () {
        var url = window.location.href;
        var copied = b.getAttribute('data-copied-label') || 'Copied!';
        var done = function () { var t = b.textContent; b.textContent = copied; setTimeout(function () { b.textContent = t; }, 1600); };
        if (navigator.share) { navigator.share({ url: url, title: document.title }).catch(function () {}); return; }
        if (navigator.clipboard) { navigator.clipboard.writeText(url).then(done, function () {}); }
      });
    });
  }

  /* ═══ 11 · Day / Night drag comparison ═══ */
  var dnWinBound = false;
  function initDayNight() {
    $$('[data-dn5p-daynight]').forEach(function (el) {
      var set = function (pct) { el.style.setProperty('--dn5p-dn', Math.max(0, Math.min(100, pct)) + '%'); };
      set(50);
      var drag = false;
      var at = function (clientX) {
        var r = el.getBoundingClientRect();
        set(((clientX - r.left) / r.width) * 100);
      };
      el.addEventListener('pointerdown', function (e) { drag = true; at(e.clientX); });
      el.addEventListener('pointermove', function (e) { if (drag) at(e.clientX); });
      var up = function () { drag = false; };
      if (!dnWinBound) { dnWinBound = true; window.addEventListener('pointerup', up); window.addEventListener('pointercancel', up); }
    });
  }

  /* ═══ boot ═══
     Document-level delegation may be bound only once: in the Theme editor shopify:section:load reruns boot(),
     and binding again makes one click fire twice (an accordion opens and closes at once). */

  /* ═══ 13 · Spec card 07: "+ SHIPPING · {amount} away" on tiers below the threshold ═══
     No money is computed here: the amount is data-dn-fs-gap-cents that dn-free-shipping-progress-v4
     writes on every .bundle-tier (visitor-currency cents), formatted by the engine's themeFormatMoney.
     Shown only to data-bundle-free-shipping-market="1" visitors (same audience as the FREE label);
     free tiers (data-dn-fs-met="1" / .bundle-tier__ship.is-free) get nothing (engine shows ✓ FREE SHIPPING). */
  function fsMoney(c) {
    var t = typeof window.themeFormatMoney === 'function' ? window.themeFormatMoney(c) : null;
    return t && !/NaN|undefined/.test(t) ? t : null;
  }
  var tierShipPaint = null, tierShipMo = null;
  function initTierShip() {
    var wrap = $(ROOT_SEL + ' [data-dn5p-tiership]');
    if (!wrap) return;
    var on = wrap.getAttribute('data-dn5p-tiership') === 'true';
    var tpl = wrap.getAttribute('data-ship-text') || '';
    var pill = wrap.getAttribute('data-ship-pill') || '';
    function paint() {
      var market = document.body.getAttribute('data-bundle-free-shipping-market') === '1';
      $$('.bundle-tier', wrap).forEach(function (t) {
        var host = t.querySelector('.px-4 .flex-1');
        var note = t.querySelector('.dn5p-tship');
        var gap = parseInt(t.getAttribute('data-dn-fs-gap-cents'), 10);
        var met = t.getAttribute('data-dn-fs-met') === '1' || !!t.querySelector('.bundle-tier__ship.is-free');
        var amt = (on && market && host && isFinite(gap) && gap > 0 && !met && tpl.indexOf('{amount}') > -1) ? fsMoney(gap) : null;
        if (!amt) { if (note) note.parentNode.removeChild(note); return; }
        var line = '· ' + tpl.split('{amount}').join(amt);
        if (note && note.getAttribute('data-line') === line && note.parentNode === host) return;
        if (!note) {
          note = document.createElement('div'); note.className = 'dn5p-tship';
          var p = document.createElement('span'); p.className = 'dn5p-tship__pill';
          note.appendChild(p); note.appendChild(document.createTextNode(''));
        }
        note.firstChild.textContent = pill;
        note.lastChild.textContent = line;
        note.setAttribute('data-line', line);
        if (note.parentNode !== host) host.appendChild(note);
      });
    }
    paint();
    if (!tierShipPaint) document.addEventListener('dn:freeship', function () { if (tierShipPaint) tierShipPaint(); });
    tierShipPaint = paint;
    if (tierShipMo) tierShipMo.disconnect();
    if (window.MutationObserver) {
      tierShipMo = new MutationObserver(paint);
      tierShipMo.observe(wrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-dn-fs-gap-cents', 'data-dn-fs-met'] });
    }
  }

  /* Upgrade only visible engine-selected Related cards with the existing dn5 card view.
     The engine still owns recommendation choice, de-duplication and infinite loading. */
  var relatedTrack = null, relatedVisibility = null, relatedChanges = null, relatedGeneration = 0;
  var relatedHtml = Object.create(null), relatedQueue = [], relatedActive = 0, RELATED_MAX_IN_FLIGHT = 4;
  function pumpRelatedCards() {
    while (relatedActive < RELATED_MAX_IN_FLIGHT && relatedQueue.length) {
      (function (job) {
        relatedActive++;
        var controller = new AbortController();
        var timer = setTimeout(function () { controller.abort(); }, 15000);
        Promise.resolve().then(function () {
          var route = window.dnRoute || function (path) { return '/' + path; };
          return fetch(route('products/' + encodeURIComponent(job.handle) + '?view=dn5card'), { credentials: 'same-origin', signal: controller.signal });
        })
          .then(function (response) { return response.ok ? response.text() : null; })
          .catch(function () { return null; })
          .then(function (html) { job.resolve(html); })
          .finally(function () { clearTimeout(timer); relatedActive--; pumpRelatedCards(); });
      })(relatedQueue.shift());
    }
  }
  function relatedCardHtml(handle) {
    if (!relatedHtml[handle]) {
      relatedHtml[handle] = new Promise(function (resolve) {
        relatedQueue.push({ handle: handle, resolve: resolve });
        pumpRelatedCards();
      });
    }
    return relatedHtml[handle];
  }
  function initRelatedCards() {
    var track = document.querySelector('[data-ymal-track]');
    if (!track || track === relatedTrack || !window.__dn5c || !window.IntersectionObserver || !window.MutationObserver) return;
    if (relatedVisibility) relatedVisibility.disconnect();
    if (relatedChanges) relatedChanges.disconnect();
    relatedTrack = track;
    var generation = ++relatedGeneration;
    var visibility = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        visibility.unobserve(entry.target);
        var wrapper = entry.target, handle = wrapper.getAttribute('data-dn5-card-handle');
        relatedCardHtml(handle).then(function (html) {
          if (!html || generation !== relatedGeneration || !track.contains(wrapper)) return;
          try {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var card = parsed.querySelector('[data-dn5c-card]');
            var quick = card && card.querySelector('[data-quick-add][data-product-handle]');
            if (!quick || quick.getAttribute('data-product-handle') !== handle) return;
            card.querySelectorAll('[data-dn5c-rate]').forEach(function (rate) { rate.remove(); });
            wrapper.replaceChildren(document.importNode(card, true));
          } catch (e) { /* Invalid card response: keep the working engine card. */ }
        });
      });
    }, { rootMargin: '300px 0px' });
    relatedVisibility = visibility;
    function watch(wrapper) {
      if (!wrapper || wrapper.nodeType !== 1 || wrapper.hasAttribute('data-dn5-card-handle')) return;
      var quick = wrapper.querySelector('.product-card [data-quick-add][data-product-handle]');
      var handle = quick && quick.getAttribute('data-product-handle');
      if (!handle) return;
      wrapper.setAttribute('data-dn5-card-handle', handle);
      visibility.observe(wrapper);
    }
    Promise.resolve(window.__duniiiYmalInitialReady || []).catch(function () { return []; }).then(function () {
      if (generation !== relatedGeneration) return;
      Array.prototype.forEach.call(track.children, watch);
      relatedChanges = new MutationObserver(function (records) {
        records.forEach(function (record) { record.addedNodes.forEach(watch); });
      });
      relatedChanges.observe(track, { childList: true });
    });
  }

  /* Reviews keep the engine's rendered cards and one real Write button. The
     desktop skin places that button by the rating; the engine can replace its
     content on every filter/page action, so re-home only the newly bound node. */
  var reviewLayout = null;
  var completeLayout = null;
  function initCompleteLayout() {
    var grid = document.querySelector('body[data-template="product"] #complete-the-look #ctl-grid');
    if (completeLayout && completeLayout.grid !== grid) { completeLayout.observer.disconnect(); completeLayout = null; }
    if (!grid || completeLayout) return;
    function placeButtons() {
      grid.querySelectorAll('.ctl-card').forEach(function (card) {
        var body = card.querySelector('.ctl-card__body');
        var quick = card.querySelector('.product-card__quick-add');
        if (body && quick && quick.parentElement !== body) body.appendChild(quick);
      });
    }
    var observer = new MutationObserver(placeButtons);
    observer.observe(grid, { childList: true });
    completeLayout = { grid: grid, observer: observer };
    placeButtons();
  }
  function initReviewLayout() {
    var section = document.querySelector('body[data-template="product"] #reviews');
    if (reviewLayout && reviewLayout.section !== section) { reviewLayout.cleanup(); reviewLayout = null; }
    if (!section || reviewLayout) return;
    var content = section.querySelector('#reviews-content');
    var container = section.querySelector(':scope > .container');
    if (!content || !container) return;
    var left = document.createElement('div');
    left.className = 'dn5-review-left';
    var title = section.querySelector('#reviews-title');
    var eyebrow = title && title.querySelector('p');
    var eyebrowBase = eyebrow && eyebrow.textContent.trim();
    var summary = section.querySelector('.reviews-summary');
    container.insertBefore(left, title || content);
    if (title) left.appendChild(title);
    var rating = section.querySelector('#dn2-rating-card');
    if (rating) left.appendChild(rating);
    if (summary) left.appendChild(summary);
    var state = { section: section, current: null, ready: false, observer: null };
    var desktop = window.matchMedia('(min-width: 990px)');
    function openExistingSheet(event) {
      var sheet = document.getElementById('dn2-write-review');
      if (!sheet || !window.DN2 || typeof window.DN2.openSheet !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.DN2.openSheet(sheet);
    }
    function sync() {
      /* The engine fills this five-row node from the existing reviews response.
         Until it arrives, the Liquid defaults are only placeholders. */
      var distribution = section.querySelector('#reviews-distribution');
      if (summary && distribution && distribution.querySelectorAll('.reviews-dist-row').length === 5) {
        summary.classList.add('dn5-review-ready');
        var countText = section.querySelector('#reviews-count-text');
        var count = countText && countText.textContent.trim().match(/^(\d[\d,]*)\s+reviews?\b/i);
        if (eyebrow && eyebrowBase && eyebrowBase.toUpperCase() === 'REVIEWS' && count) {
          var liveEyebrow = eyebrowBase + ' · ' + count[1];
          if (eyebrow.textContent !== liveEyebrow) eyebrow.textContent = liveEyebrow;
        }
      }
      /* The shared photo viewer delegates only to .review-card-v2. The first
         real photo review already has that card's DOM, but its hero class alone
         was hidden in the black skin; register the same node with the viewer. */
      var hero = content.querySelector('.review-hero-v2');
      if (hero) hero.classList.add('review-card-v2');
      var rating = section.querySelector('#dn2-rating-card');
      if (rating && rating.parentElement !== left) left.insertBefore(rating, summary || null);
      var wrap = content.querySelector('.review-ctas-wrap');
      [['most-recent', 'Most recent'], ['most-helpful', 'Most helpful'], ['with-photos', 'With photos']].forEach(function (entry) {
        var filter = content.querySelector('[data-review-filter="' + entry[0] + '"]');
        if (filter && filter.textContent !== entry[1]) filter.textContent = entry[1];
      });
      var fresh = wrap && wrap.querySelector('#reviews-write');
      if (!state.ready) {
        /* The shared section must bind its initial data-wr-open listener first. */
        if (!wrap || !wrap.querySelector('[data-wr-open]')) return;
        state.ready = true;
      }
      if (fresh && fresh !== state.current) {
        if (state.current && state.current.isConnected) state.current.remove();
        state.current = fresh;
        fresh.setAttribute('data-dn5-review-write', '');
        fresh.addEventListener('click', openExistingSheet, true);
      }
      if (!wrap || content.style.display === 'none') {
        if (state.current && state.current.isConnected) state.current.remove();
        state.current = null;
        return;
      }
      var button = state.current;
      if (!button || !button.isConnected) return;
      var hasCards = !!content.querySelector('.review-hero-v2,.review-grid .review-card-v2');
      if (desktop.matches && hasCards) {
        if (button.parentElement !== left) left.appendChild(button);
        if (button.id) button.removeAttribute('id');
      } else {
        if (button.parentElement !== wrap) wrap.appendChild(button);
        if (button.id !== 'reviews-write') button.id = 'reviews-write';
      }
    }
    state.observer = new MutationObserver(sync);
    state.observer.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-wr-open', 'style'] });
    desktop.addEventListener('change', sync);
    state.cleanup = function () { state.observer.disconnect(); desktop.removeEventListener('change', sync); };
    reviewLayout = state;
    sync();
  }

  /* ═══ 14 · bundle item colour / size panels (design "duniii PDP 2c Goodnight Terry" §15, bundleItem()) ═══
     🔴 Not one cent and not one pick is decided here. The engine opens/closes the panels (hidden + aria-expanded) and
        handles every colour / size click; this only
        ① colour rows show the colour's product thumbnail (store owner request 2026-10-24): the <img>
          the engine already put in each option (#bd-swatches, width=96; Perfect Pair companion = the pair product's
          variant image, given width=96 here before it first loads). A colour with no image, or whose image fails to
          load, falls back to the colour circle (--dn5p-sw from #bd-swatch-colors, the same colour truth the section
          already prints for the engine), ② adds the panel footer of the design ("Set #n only" · "Apply to all
          n sets" / "Size guide"), ③ re-fits the open tier card height to the inline panel (the engine fixes it once at
          open time, so the inline panel was clipped). "Apply to all" clicks the engine's own option buttons in the
          other rows, so the cart lines still come from the engine's per-row state. Layout lives in dn5-pdp-v16.css § 26. */
  function initTierItemPanels() {
    var wrap = $('.bundle-tiers');
    if (!wrap || wrap.__dn5pPanels) return;
    wrap.__dn5pPanels = true;
    var hex = {};
    try { hex = JSON.parse((document.getElementById('bd-swatch-colors') || {}).textContent || '{}') || {}; } catch (e) { hex = {}; }
    var setOnly = wrap.getAttribute('data-dn5p-set-only') || '';
    var applyAll = wrap.getAttribute('data-dn5p-apply-all') || '';
    function sgTrigger() { return $('.dn5p-sgtrig[data-dn5p-open="dn5p-size-guide"]:not([hidden])'); }
    function rowsOf(tier) { return tier ? $$('.tier-size-row.dn5p-ti', tier) : []; }
    function fill(s, n, count) { return String(s).replace(/\{n\}/g, n).replace(/\{count\}/g, count); }
    function dot(b, h) {
      if (!h || b.hasAttribute('data-dn5p-sw')) return;
      b.setAttribute('data-dn5p-sw', ''); b.style.setProperty('--dn5p-sw', h);
    }
    function decorate(menu) {
      $$('.tier-color-btn[data-color], .pc-color-btn', menu).forEach(function (b) {
        if (b.__dn5pThumb) return;
        b.__dn5pThumb = true;
        var h = hex[b.getAttribute('data-color') || b.getAttribute('data-pc-val')];
        var img = b.querySelector(':scope > img');
        if (!img || !img.getAttribute('src')) { dot(b, h); return; }
        var src = img.getAttribute('src');
        if (!/[?&]width=\d/.test(src)) img.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=96');
        img.addEventListener('error', function () { dot(b, h || '#c5cedc'); });
        if (img.complete && img.naturalWidth === 0) dot(b, h || '#c5cedc');
      });
      /* Perfect Pair rows (§15): the design's size panel footer is "Size guide" only (pairItem(): multi = false).
         For the pair companion it is offered only when the size chart actually has a table for that product. */
      if (menu.closest('.bundle-tier[data-pair="1"]')) {
        if (!menu.closest('.is-size') || menu.querySelector('.dn5p-ti__foot')) return;
        var psg = sgTrigger();
        if (!psg) return;
        var comp = menu.closest('[data-pair-companion]');
        if (comp && !pairSgCovers(pairCompTitle(comp))) return;
        var pf = document.createElement('div');
        pf.className = 'dn5p-ti__foot';
        pf.innerHTML = '<button type="button" class="dn5p-ti__link" data-dn5p-ti-sg>' + esc(psg.textContent.trim()) + '</button><span></span>';
        menu.appendChild(pf);
        return;
      }
      var row = menu.closest('.tier-size-row.dn5p-ti');
      if (!row || menu.querySelector('.dn5p-ti__foot')) return;
      var rows = rowsOf(row.closest('.bundle-tier'));
      var multi = rows.length > 1, n = rows.indexOf(row) + 1;
      var left = '', right = '';
      if (menu.closest('.is-color')) {
        if (!multi) return;
        left = setOnly ? '<span class="dn5p-ti__only">' + esc(fill(setOnly, n, rows.length)) + '</span>' : '';
      } else {
        var sg = sgTrigger();
        if (sg) left = '<button type="button" class="dn5p-ti__link" data-dn5p-ti-sg>' + esc(sg.textContent.trim()) + '</button>';
      }
      if (multi && applyAll) right = '<button type="button" class="dn5p-ti__link" data-dn5p-ti-all>' + esc(fill(applyAll, n, rows.length)) + '</button>';
      if (!left && !right) return;
      var f = document.createElement('div');
      f.className = 'dn5p-ti__foot';
      f.innerHTML = (left || '<span></span>') + right;
      menu.appendChild(f);
    }
    function refit() {
      $$('.bundle-tier.is-active', wrap).forEach(function (tier) {
        $$('.bundle-tier__body', tier).forEach(function (b) {
          if (b.closest('.bundle-tier') !== tier) return;
          var mh = b.style.maxHeight;
          if (!mh || mh === 'none' || parseFloat(mh) === 0) return;
          b.style.maxHeight = b.scrollHeight + 'px';
        });
      });
    }
    function closeMenus() {
      $$('.bundle-variant-select__menu', wrap).forEach(function (m) {
        if (m.hidden) return;
        m.hidden = true;
        var tr = m.parentElement && m.parentElement.querySelector('.bundle-variant-select__trigger');
        if (tr) tr.setAttribute('aria-expanded', 'false');
      });
    }
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        var seen = false;
        muts.forEach(function (m) {
          var t = m.target;
          if (!t.classList || !t.classList.contains('bundle-variant-select__menu')) return;
          seen = true;
          if (!t.hidden) decorate(t);
        });
        if (seen) refit();
      }).observe(wrap, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
    }
    wrap.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var all = t.closest('[data-dn5p-ti-all]'), sgb = t.closest('[data-dn5p-ti-sg]');
      if (!all && !sgb) return;
      e.preventDefault();
      var row = t.closest('.tier-size-row');
      closeMenus();
      if (sgb) { var sg = sgTrigger(); if (sg) sg.click(); return; }
      if (!row) return;
      var c = row.querySelector('.tier-color-btn.is-active');
      var z = row.querySelector('.size-btn[data-size].is-selected');
      rowsOf(row.closest('.bundle-tier')).forEach(function (r) {
        if (r === row) return;
        if (c) {
          var cb = $$('.tier-color-btn', r).filter(function (b) { return b.dataset.color === c.dataset.color; })[0];
          if (cb && !cb.disabled && !cb.classList.contains('is-active')) cb.click();
        }
        if (z) {
          var zb = $$('.size-btn[data-size]', r).filter(function (b) { return b.dataset.size === z.dataset.size; })[0];
          if (zb && !zb.disabled && !zb.classList.contains('is-selected')) zb.click();
        }
      });
      closeMenus();
    });
  }

  /* ═══ 15 · Perfect Pair tier (design "duniii PDP 2c Goodnight Terry" pair tier: stacked thumbnails L113/L126,
         pairItem() rows L136-L151) ═══
     🔴 Not one cent and not one pick is decided here. The engine still builds the pair tier, fetches the companion,
        prices both lines and owns every colour / size pick and the cart lines (Bundle "Pair", _bundle_line_index,
        _bundle_deal_id, _bundle_bar_id). This only
        ① puts the two products' images, stacked, into the tier header and both product names into the header chip,
        ② numbers the rows (#1 / #2), takes the engine's lightbox / quick-view hooks off the row image and names
           (the companion thumbnail opens the shared Quick View instead, see ④),
        ③ shows the companion thumbnail as the picked colour's image with a VIEW band + colour dot,
        ④ opens the store's one Quick View (window.DN2.quickShop — the same popup as You may also like / Quick Add) for the
           companion, preselected on the colour · size picked in the pair row. Store owner 2026-10-31 14:29 EDT: reuse the
           You may also like popup; the pair-only "IN YOUR PAIR" sheet is retired. The popup's own Add to Cart is the Quick
           View's (one line, that product's own price); the pair's two lines still go in through the tier's Add to Cart.
        Layout lives in dn5-pdp-v18.css § 27. */
  var pairJson = {};
  function pairCompTitle(card) {
    var t = card && card.querySelector('.bundle-line-item__title');
    return t ? t.textContent.replace(/\s+×\s*\d+\s*$/, '').trim() : '';
  }
  /* the size chart covers a companion only when one of its tables is titled "<that product's title> · …" */
  function pairSgCovers(title) {
    if (!title) return false;
    var tables = sgTables() || [];
    for (var i = 0; i < tables.length; i++) {
      if (String((tables[i] && tables[i].title) || '').indexOf(title + ' · ') === 0) return true;
    }
    return false;
  }
  function cdnW(src, w) {
    if (!src) return '';
    src = String(src).replace(/([?&])width=\d+(&?)/, function (m, a, b) { return b ? a : ''; });
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function initPairTier() {
    var wrap = $('.bundle-tiers');
    if (!wrap || wrap.__dn5pPair) return;
    wrap.__dn5pPair = true;
    var hero = wrap.getAttribute('data-dn5p-pair-hero') || '';
    var viewLbl = wrap.getAttribute('data-dn5p-pair-view') || '';
    var outLbl = wrap.getAttribute('data-dn5p-pair-out') || '';
    var targetTitle = wrap.getAttribute('data-product-title') || '';
    var hex = {}, hexHandle = '';
    var hexEl = document.getElementById('dn5p-pair-swatch-colors');
    if (hexEl) {
      try { hex = JSON.parse(hexEl.textContent || '{}') || {}; hexHandle = hexEl.getAttribute('data-handle') || ''; } catch (e) { hex = {}; }
    }
    function compHex(card, colour) {
      return (colour && hexHandle && card.getAttribute('data-dn5p-handle') === hexHandle && hex[colour]) || '';
    }
    function label(scope, kind) {
      var l = scope && scope.querySelector('.is-' + kind + ' [data-bundle-selected-label]');
      return l ? l.textContent.trim() : '';
    }
    function unhook(el, attrs) { if (el) attrs.forEach(function (a) { if (el.hasAttribute(a)) el.removeAttribute(a); }); }
    function setAttr(el, a, v) { if (el.getAttribute(a) !== v) el.setAttribute(a, v); }
    function number(host, n) {
      var el = host.querySelector(':scope > .dn5p-pp__n');
      if (!el) { el = document.createElement('span'); el.className = 'dn5p-pp__n'; el.setAttribute('aria-hidden', 'true'); host.insertBefore(el, host.firstChild); }
      if (el.textContent !== '#' + n) el.textContent = '#' + n;
    }
    function decorate(tier) {
      var card = tier.querySelector('[data-pair-companion]');
      var rows = $$('.tier-pair-target-row', tier);
      /* ② target rows: number + engine lightbox / quick-view hooks off; sold-out colours get the design's label */
      rows.forEach(function (r, i) {
        var line = r.querySelector('.bundle-line-item');
        if (line) number(line, i + 1);
        unhook(r.querySelector('.tier-item-thumb'), ['data-pairux-zoom', 'title']);
        var rt = r.querySelector('.bundle-line-item__title');
        unhook(rt, ['data-pairux-qv', 'data-pairux-handle', 'role', 'tabindex']);
        if (rt) setAttr(rt, 'title', rt.textContent.trim());   /* names are one line + ellipsis (CSS); full title on hover */
        if (outLbl) $$('.tier-color-btn:disabled', r).forEach(function (b) { setAttr(b, 'data-dn5p-out', outLbl); });
      });
      var compTitle = '', feat = '';
      if (card && card.querySelector('.bundle-line-item__content')) {
        var box = card.querySelector('.bundle-line-item__image');
        var tEl = card.querySelector('.bundle-line-item__title');
        if (box && box.hasAttribute('data-pairux-img')) setAttr(card, 'data-dn5p-feat', box.getAttribute('data-pairux-img') || '');
        if (tEl && tEl.hasAttribute('data-pairux-handle')) setAttr(card, 'data-dn5p-handle', tEl.getAttribute('data-pairux-handle') || '');
        unhook(box, ['data-pairux-zoom', 'data-pairux-img', 'title']);
        unhook(tEl, ['data-pairux-qv', 'data-pairux-handle', 'role', 'tabindex']);
        if (tEl) setAttr(tEl, 'title', tEl.textContent.trim());
        compTitle = pairCompTitle(card);
        feat = card.getAttribute('data-dn5p-feat') || '';
        number(card, rows.length + 1);
        /* ③ companion thumbnail = picked colour's image, VIEW band, colour dot; opens the Quick View (④) */
        if (box) {
          var act = card.querySelector('.pc-color-btn.is-active img');
          var src = cdnW((act && act.getAttribute('src')) || feat, 200);
          var im = box.querySelector('img');
          if (im && src && im.getAttribute('src') !== src) im.setAttribute('src', src);
          setAttr(box, 'data-dn5p-qv', '');
          setAttr(box, 'role', 'button');
          setAttr(box, 'tabindex', '0');
          setAttr(box, 'aria-label', ((viewLbl ? viewLbl + ' · ' : '') + compTitle).trim());
          if (viewLbl && !box.querySelector('.dn5p-pp__view')) {
            var v = document.createElement('span'); v.className = 'dn5p-pp__view'; v.setAttribute('aria-hidden', 'true'); v.textContent = viewLbl; box.appendChild(v);
          }
          var h = compHex(card, label(card, 'color'));
          var dot = box.querySelector('.dn5p-pp__dot');
          if (h && !dot) { dot = document.createElement('span'); dot.className = 'dn5p-pp__dot'; dot.setAttribute('aria-hidden', 'true'); box.appendChild(dot); }
          if (dot && !h) dot.parentNode.removeChild(dot);
          if (dot && h && dot.style.getPropertyValue('--dn5p-sw') !== h) dot.style.setProperty('--dn5p-sw', h);
        }
      }
      /* ① header: stacked images + both names in the chip (only once the engine has found the companion) */
      var flex = tier.querySelector(':scope > .px-4 > .flex');
      var radio = flex && flex.querySelector(':scope > .bundle-tier__radio');
      var stack = flex && flex.querySelector(':scope > .dn5p-pp__stack');
      if (flex && radio && hero && feat) {
        var fs = cdnW(feat, 160);
        if (!stack) {
          stack = document.createElement('span');
          stack.className = 'dn5p-pp__stack';
          stack.setAttribute('aria-hidden', 'true');
          stack.innerHTML = '<span class="dn5p-pp__ph"><img alt="" src="' + esc(hero) + '"></span><span class="dn5p-pp__ph"><img alt=""></span><span class="dn5p-pp__plus">+</span>';
          radio.parentNode.insertBefore(stack, radio.nextSibling);
        }
        var i2 = stack.querySelectorAll('img')[1];
        if (i2.getAttribute('src') !== fs) i2.setAttribute('src', fs);
      } else if (stack) stack.parentNode.removeChild(stack);
      var meta = tier.querySelector('.bundle-tier__meta');
      var chip = meta && meta.querySelector('.dn5p-pp__names');
      var names = targetTitle && compTitle ? targetTitle + ' + ' + compTitle : '';
      if (meta && names) {
        if (!chip) { chip = document.createElement('span'); chip.className = 'dn5p-pp__names'; meta.insertBefore(chip, meta.firstChild); }
        if (chip.textContent !== names) { chip.textContent = names; chip.setAttribute('title', names); }
      } else if (chip) chip.parentNode.removeChild(chip);
      /* the engine fixes the open body height when it opens; keep it in step with what was added */
      if (tier.classList.contains('is-active')) {
        var body = tier.querySelector(':scope > .bundle-tier__body');
        var mh = body && body.style.maxHeight;
        if (body && mh && mh !== 'none' && parseFloat(mh) > 0 && parseFloat(mh) !== body.scrollHeight) body.style.maxHeight = body.scrollHeight + 'px';
      }
    }
    var queued = false;
    function run() {
      queued = false;
      $$('.bundle-tier[data-pair="1"]', wrap).forEach(decorate);
    }
    function queue() { if (!queued) { queued = true; setTimeout(run, 0); } }
    run();
    if (window.MutationObserver) new MutationObserver(queue).observe(wrap, { childList: true, subtree: true, characterData: true });

    /* ④ companion thumbnail → the shared Quick View, on the variant picked in the pair row (the engine keeps its pick
       internal, so it is read back from the row's active colour / size buttons against /products/<handle>.js) */
    function productJson(handle) {
      if (!pairJson[handle]) {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        pairJson[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }
      return pairJson[handle];
    }
    function pickedVariantId(card, p) {
      var want = {};
      $$('.pc-color-btn.is-active[data-pc-opt-idx], .pc-size-btn.is-selected[data-pc-opt-idx]', card).forEach(function (b) {
        want[b.getAttribute('data-pc-opt-idx')] = b.getAttribute('data-pc-val');
      });
      var keys = Object.keys(want);
      if (!p || !keys.length) return null;
      for (var i = 0; i < (p.variants || []).length; i++) {
        var v = p.variants[i];
        if (keys.every(function (k) { return String((v.options || [])[k]) === String(want[k]); })) return v.id;
      }
      return null;
    }
    function openQuickView(tier) {
      var card = tier && tier.querySelector('[data-pair-companion]');
      var handle = card && card.getAttribute('data-dn5p-handle');
      var qs = window.DN2 && window.DN2.quickShop;
      if (!handle || !qs || !qs.open) return;
      productJson(handle).then(function (p) {
        var vid = pickedVariantId(card, p);
        qs.open(handle, [handle], 0, vid ? { variantId: vid } : undefined);
      });
    }
    wrap.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-dn5p-qv]') : null;
      if (!t) return;
      e.preventDefault(); e.stopPropagation();
      openQuickView(t.closest('.bundle-tier'));
    });
    wrap.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target && e.target.closest ? e.target.closest('[data-dn5p-qv]') : null;
      if (!t) return;
      e.preventDefault(); e.stopPropagation();
      openQuickView(t.closest('.bundle-tier'));
    });
  }

  var docBound = false;
  function boot() {
    if (!root()) return;
    if (!docBound) {
      docBound = true;
      initAccordions();
      initSheets();
      initGiftDetail();
    }
    initSizeGuide();
    initJourney();
    initBundleToNativeSync();
    initDefaultVariant();
    initSizeLabel();
    initTierKeyboard();
    initTierItemPanels();
    initPairTier();
    initFloatSizes();
    initFloatSub();
    initShare();
    initDayNight();
    initTierShip();
    initRelatedCards();
    initCompleteLayout();
    initReviewLayout();
  }
  /* ── rating: filled from the avalonae-reviews app proxy (2026-10-17) ──────────────
     The truth is not in the standard Shopify metafield: reviews.rating = 0 store-wide,
     custom.json_reviews exists on only 3 products. The real source is the same app proxy as the black skin / dn4:
       /apps/reviews/product-reviews?handle=<handle>&product_id=<id>
     Measured on 43 active products: 26 have reviews, 4391 in total.
     🔴 product_id is required — with handle only it returns total_count:0, silently short, no error.
     Not one cent is calculated here, only the rating is drawn; no reviews = stay hidden, never draw empty stars. */
  function initRating() {
    var a = document.querySelector('[data-dn5p-rate]');
    if (!a || a.getAttribute('data-rate-done')) return;
    var h = a.getAttribute('data-rate-handle'), id = a.getAttribute('data-rate-id');
    if (!h || !id) return;
    a.setAttribute('data-rate-done', '1');
    fetch('/apps/reviews/product-reviews?handle=' + encodeURIComponent(h) +
          '&product_id=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var n = (j && j.total_count) || 0;
        var txt = a.querySelector('#pdp-rating-text');
        if (!n) { a.hidden = true; return; }        // no reviews: never draw empty stars
        var avg = Math.round(((j.average_rating || 0) * 10)) / 10;
        if (txt) txt.textContent = avg.toFixed(1) + ' · ' + n + ' ' + (a.getAttribute('data-rate-word') || 'reviews');
        a.hidden = false;
      })
      .catch(function () { /* nothing fetched = keep the state Liquid gave, never draw half a widget */ });
  }

  ready(initRating);
  ready(boot);
  /* re-wire after the Theme editor re-renders the section */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector(ROOT_SEL)) { boot(); initRating(); }
  });
})();
